import { render, staticRenderFns } from "./TravelTravellerForm.vue?vue&type=template&id=5a1b3c3f&scoped=true"
import script from "./TravelTravellerForm.vue?vue&type=script&lang=js"
export * from "./TravelTravellerForm.vue?vue&type=script&lang=js"
import style0 from "./TravelTravellerForm.vue?vue&type=style&index=0&id=5a1b3c3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1b3c3f",
  null
  
)

export default component.exports